<template>
  <div
    class="relative min-h-screen w-full bg-black text-white font-sans overflow-hidden container-com-brilho rounded-t-[3rem]">

    <div class="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">

      <section class="mb-20 md:mb-32">
        <header class="mb-12 flex justify-center">
          <div class="w-64 h-24 flex items-center justify-center text-white rounded-lg">
            <img src="@/assets/logopdv.png" alt="Logo OverX PDV" class="w-64" />
          </div>
        </header>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">

          <div class="text-white text-base md:text-lg leading-relaxed">
            <p>
              A OverX é uma plataforma inovadora que foi criada para simplificar e otimizar a gestão de estabelecimentos
              de food service. Seu objetivo é integrar todos os processos operacionais em um único sistema inteligente,
              permitindo que os donos de restaurantes e bares tenham controle total sobre o fluxo de pedidos, entregas e
              comunicação entre a cozinha, atendimento e clientes.
            </p>
          </div>

          <div
            class="h-64 flex items-center justify-center bg-white/5 border border-dashed border-gray-700 rounded-lg text-gray-500">
            <img src="@/assets/pdv.png" alt="Exemplo do componente OverX"
              class="rounded-lg shadow-2xl shadow-orange-500/10">
          </div>
        </div>
      </section>

      <section>
        <header class="mb-12 flex justify-center">
          <div class="w-64 h-24 flex items-center justify-center text-white rounded-lg">
            <img src="@/assets/logoapp.png" alt="Logo OverX PDV" class="w-64" />
          </div>
        </header>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">

          <div
            class="h-64 flex items-center justify-center bg-white/5 border border-dashed border-gray-700 rounded-lg text-gray-500 md:order-first">
            <img src="@/assets/store.png" alt="Exemplo do componente OverX"
              class="rounded-lg shadow-2xl shadow-orange-500/10">
          </div>

          <div class="text-white text-base md:text-lg leading-relaxed">
            <p>
              Com a OverX, você tem gestão centralizada de todos os pedidos, seja do delivery, atendimento à mesa ou na
              retirada, o que permite um maior controle e eficiência em tempo real. A plataforma automatiza as tarefas
              repetitivas e reduz erros operacionais, permitindo que sua equipe se concentre em oferecer uma experiência
              de alta qualidade ao cliente.
            </p>
          </div>

        </div>
      </section>

    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.container-com-brilho::before,
.container-com-brilho::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  z-index: 10;
}

.container-com-brilho::before {
  left: 0;
}

.container-com-brilho::after {
  right: 0;
}

.font-sans {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
</style>